var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chosenUniversity"},[_c('div',{staticClass:"columns"},[_vm._m(0),_c('div',{staticClass:"column"},[_c('p',{staticClass:"nameUniversity"},[_vm._v(_vm._s(_vm.institution))])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column is-3"},[_c('h1',{staticClass:"titleUniversity"},[_vm._v("INSTITUCIÓN")])])
}]

export { render, staticRenderFns }